import { alpha, Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import { DefaultButton, MainCheckbox, SuccessButton } from "..";
import { useEffect, useState } from "react";
import { getProjectDomain } from "../../utils/stringFormat";

export default function UserProjectsModal({
    open,
    onClose,
    onFinish,
    user,
    projects,
}) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 360,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };
    const [selectedProjects, setSelectedProjects] = useState([]);

    useEffect(() => {
        if (user) {
            setSelectedProjects(user.projects ?? []);
        }
    }, [user, open]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-user-role-title"
            aria-describedby="modal-user-role-description"
        >
            <Box sx={style}>
                <Typography id="modal-user-role-title"
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.semiBold,
                        fontSize: Constants.Styles.fontSize.lg,
                        lineHeight: Constants.Styles.lineHeight.lg,
                    }}
                >
                    Project Access
                </Typography>

                <Box>
                    <Typography
                        sx={{
                            fontWeight: Constants.Styles.fontWeight.normal,
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                            marginBlock: "1.5rem 0.5rem",
                            color: Constants.Colors[currentMode].mutedForeground,
                        }}
                    >Select which projects <b
                        style={{
                            color: Constants.Colors[currentMode].foreground,
                        }}>{user?.user_id}</b> can access</Typography>
                </Box>
                <Stack
                    spacing={"0.75rem"}
                    sx={{
                        maxHeight: 500,
                        overflowY: "scroll",
                    }}
                >
                    {projects?.map((p, index) => {
                        const checked = selectedProjects.filter((item) => item.project_id === p.project_id).length > 0;
                        return (
                            <Stack
                                key={index}
                                direction={"column"}
                                spacing={"1.125rem"}
                                sx={{
                                    padding: "0.75rem 0.25rem",
                                    backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.3),
                                    borderRadius: `calc(${Constants.Styles.radius.base} * 1)`,
                                    border: `1px solid ${Constants.Colors[currentMode].border}`,
                                }}
                            >
                                <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    justifyContent={"start"}
                                    spacing={1}
                                >
                                    <MainCheckbox
                                        checked={checked}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedProjects([...selectedProjects, p]);
                                            } else {
                                                setSelectedProjects(selectedProjects.filter((item) => item.project_id !== p.project_id));
                                            }
                                        }}
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 20,
                                            },
                                        }}
                                        type={"info"}
                                    />
                                    <Typography
                                        sx={{
                                            fontWeight: Constants.Styles.fontWeight.medium,
                                            fontSize: Constants.Styles.fontSize.sm,
                                            lineHeight: Constants.Styles.lineHeight.sm,
                                        }}
                                    >{p.name}</Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: Constants.Styles.fontWeight.normal,
                                            fontSize: Constants.Styles.fontSize.xs,
                                            lineHeight: Constants.Styles.lineHeight.xs,
                                            color: Constants.Colors[currentMode].mutedForeground,
                                            pl: 1,
                                        }}
                                    >{getProjectDomain(p?.sitemap)}</Typography>
                                </Stack>
                            </Stack>
                        );
                    })}
                </Stack>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"end"}
                    sx={{
                        mt: "1.5rem",
                    }}
                    spacing={2}
                >
                    <DefaultButton
                        text={"Cancel"}
                        size="medium"
                        onClick={() => {
                            onClose();
                        }}
                        sx={{
                            width: 60,
                        }}
                    />
                    <SuccessButton
                        text={"Update Access"}
                        size="medium"
                        onClick={() => {
                            onFinish({
                                selectedProjects: selectedProjects,
                                user: user,
                            });
                        }}
                        sx={{
                            width: 160,
                        }}
                    />
                </Stack>
            </Box>
        </Modal>
    );
}